export * from "Search/Scenarios/Shared/Components/SearchAccountLink/index";
